import { useSelector } from 'react-redux';
import { MANAGE_VIEW_TYPE } from '../Model/Model';
import ManageMainHeader from './ManageMainHeader';
import FinesSubview from './FinesSubview';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * 
 * @Description
 * Component responsible for rendering the Fines management section within the Traffic module.
 * It includes the header (`ManageMainHeader`) for filtering and navigation,
 * and the `FinesSubview` component for displaying or editing fine-related information.
 *
 * The component uses Redux to access global states such as the development mode
 * and user permissions.
 *
 * @param {Object} props - Props passed to the Fines component.
 * @param {String} props.subView - Current subview identifier.
 * @param {Function} props.handleSubViewChange - Function to handle switching between subviews.
 * @param {String} props.searchElement - Current search input or filter value.
 * @param {Function} props.setSearchElement - Function to update the search input value.
 * @param {Boolean} props.modified - Indicates if the fines data has been modified.
 * @param {React.RefObject} props.finesSubviewRef - Ref used to access methods or data from the FinesSubview component.
 *
 */

const Fines = (props) => {
    const { subView, handleSubViewChange, modified, finesSubviewRef } = props;
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    return (
        <>
            <ManageMainHeader
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                DEV={DEV}
                permission={permission}
                viewType={MANAGE_VIEW_TYPE.FINES}
            />
            <FinesSubview modified={modified} ref={finesSubviewRef} />
        </>
    );
};

export default Fines;
